module.exports = __webpack_public_path__ + "img/xk.bab9140c.svg";